<template>
  <div class="image-uploader">
    <div
      v-if="image"
      class="help"
    >
      Drag to position and resize
    </div>
    <div
      v-if="status == 'request'"
      class="help"
    >
      Loading image....
    </div>
    <div
      v-if="status == 'error'"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <image-crop
      v-if="image"
      v-model="output"
      :image="image"
      :ratio="ratio"
      :max-width="maxWidth"
    />
    <div class="input-line">
      <a
        v-if="image"
        href="#"
        @click.prevent="image = null;"
      >Change Image</a>
      <input
        v-else
        ref="file"
        type="file"
        accept="image/*;capture=camera"
        class="form-control"
        placeholder="Choose Image"
        @change="handlePreview(null)"
      >
    </div>
  </div>
</template>

<script>
import ImageCrop from "./crop.vue";

export default {
  name: "ProfilePictureComponent",
  components: {
    ImageCrop,
  },
  props: {
    value: { type: String, default: null },
    ratio: { type: Number, default: 1 },
    maxWidth: {type: Number, default: 512 },
  },
  data() {
    return {
      image: this.value,
      output: null,
      status: null,
      error: null,
    };
  },
  watch: {
    output() {
      this.$emit("input", this.output);
    }
  },
  methods: {
    handleError(ex) {
      // ex will be null if it is canceled in a system view
      if (ex && ex.message) {
        alert(ex.message, "Profile Picture");
      }
    },

    handleCancel() {
      this.status = null;
      this.image = null;
    },

    async readFile() {
      return new Promise((resolve) => {
        let file = this.$refs.file.files[0];
        if (file) {
          let reader = new FileReader();
          reader.onload = e => {
            let result = e.target.result.split(",", 2)[1];
            setTimeout(() => resolve({ file: file.name, result }), 2000);
          };
          reader.readAsDataURL(file);
        }
        this.$refs.file.value = null;
      });
    },

    async handlePreview() {
      this.image = null;
      this.output = null;
      this.error = null;
      this.status = "request";

      let { file, result } = await this.readFile().catch(e => {
        this.status = "error";
        this.error = `Invalid image file (${e})`;
        console.log(e);
      });

      if (! this.error) {
        let ext = file.split(".").pop();
        let src = result;

        if (src) {
          // preload image
          let result = await new Promise(r => {
            let testImg = new Image();
            testImg.onload = () => {
              this.status = null;
              r(testImg.src);
            };
            testImg.onerror = e => {
              this.status = "error";
              this.error = `Failed to load image`;
              console.error(this.error, e);
              r(null);
            };
            testImg.src = `data:image/${ext};base64,${src}`;
          });

          if (result) {
            this.image = result;
          } else {
            this.image = null;
          }
        }
      }
    },
  }
};
</script>
